module.exports = __webpack_public_path__ + "img/bulb.ed8e8037.svg";